// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"ed98e949","656":"61c0f3f2","756":"4782abf4","831":"d44c92cb","968":"2e781eb7"}[chunkId] + ".chunk.js";
};